var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgToilet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4C7 3.44772 7.44772 3 8 3H16C16.5523 3 17 3.44772 17 4V11H7V4Z",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 21C8 21.5523 8.44772 22 9 22H15C15.5523 22 16 21.5523 16 21V18H8V21Z",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60896 13.0615C4.33513 12.4004 4.15182 11.707 4.06275 11H12L19.9373 11C19.8482 11.707 19.6649 12.4004 19.391 13.0615C18.989 14.0321 18.3997 14.914 17.6569 15.6569C16.914 16.3997 16.0321 16.989 15.0615 17.391C14.0909 17.7931 13.0506 18 12 18C10.9494 18 9.90914 17.7931 8.93853 17.391C7.96793 16.989 7.08601 16.3997 6.34315 15.6569C5.60028 14.914 5.011 14.0321 4.60896 13.0615Z",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToilet);
export default __webpack_public_path__ + "static/media/Toilet.755d9713c7ed0008f96faa317b16f6f5.svg";
export { ForwardRef as ReactComponent };